<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="800"
    :fullscreen="$vuetify.display.width <= 800 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <!-- <span>This is a message</span> -->
    <!-- <el-row :gutter="20"> -->
    <el-form
      class="frm-class"
      ref="ruleFormRef"
      :rules="rules"
      :model="charger_data"
      :style="[
        $vuetify.display.width >= 800 ? 'height: 450px;' : 'height: 550px;',
      ]"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert type="info" show-icon :closable="false">
          <p class="animate__fadeInDown ma-0">Charging Site :</p>
        </el-alert>

        <el-form-item prop="site_name" label="Site Name: ">
          <el-input v-model="charger_data.site_name" />
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="country" label="Country: ">
              <el-input v-model="charger_data.country" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="lat" label="Lat: ">
              <el-input v-model="charger_data.lat" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="lng" label="Lng: ">
              <el-input v-model="charger_data.lng" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="street_name" label="Street Name: ">
              <el-input v-model="charger_data.street_name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="suburb" label="Suburb: ">
              <el-input v-model="charger_data.suburb" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="state" label="State: ">
              <el-input v-model="charger_data.state" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="city" label="City: ">
              <el-input v-model="charger_data.city" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="postcode" label="Postcode: ">
              <el-input v-model="charger_data.postcode" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="what3words" label="What3words: ">
              <el-input v-model="charger_data.what3words" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="address_comment" label="Address Comment: ">
              <el-input
                v-model="charger_data.address_comment"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="site_description" label="Site Description: ">
              <el-input v-model="charger_data.site_description" type="textarea" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
      <el-space fill style="width: 100%">
        <el-alert type="info" show-icon :closable="false">
          <p class="ma-0">Charger :</p>
        </el-alert>
        <el-row :gutter="20">
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item prop="charger_id" label="Charger ID: ">
              <el-input v-model="charger_data.charger_id" />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item label="">
              <el-checkbox
                v-model="charger_data.onsite_renewable"
                label="OnSite Renewable"
                size="large"
              />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item label="">
              <el-checkbox
                v-model="charger_data.onsite_battery"
                label="OnSite Battery"
                size="large"
              />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item>
              <el-checkbox
                v-model="charger_data.is_included"
                label="Is Included"
                size="large"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item prop="year_added" label="Year Added: ">
              <el-input v-model="charger_data.year_added" />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item prop="install_date" label="Install Date: ">
              <el-input v-model="charger_data.install_date" />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item prop="operational_date" label="Operational Date: ">
              <el-input v-model="charger_data.operational_date" />
            </el-form-item>
          </el-col>
          <el-col
            v-if="$vuetify.display.width >= 650 || $vuetify.display.width < 500"
            :span="$vuetify.display.width < 500 ? 12 : 6"
          >
            <el-form-item prop="decommissioning_date" label="Decommissioning Date: ">
              <el-input v-model="charger_data.decommissioning_date" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <!-- <el-form-item prop="certificate_number" label="Certificate Num: ">
              <el-input v-model="charger_data.certificate_number" />
            </el-form-item> -->
            <el-form-item prop="charger_capacity_kW" label="Charger Capacity kW: ">
              <el-input v-model="charger_data.charger_capacity_kW" />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item prop="make" label="Make">
              <el-input v-model="charger_data.make" />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item prop="model" label="Model: ">
              <el-input v-model="charger_data.model" />
            </el-form-item>
          </el-col>
          <el-col
            :span="
              $vuetify.display.width >= 650
                ? 6
                : $vuetify.display.width >= 500
                ? 8
                : 12
            "
          >
            <el-form-item prop="charger_type" label="Charger Type: ">
              <el-input v-model="charger_data.charger_type" />
            </el-form-item>
          </el-col>
          <el-col
            v-if="$vuetify.display.width >= 500 && $vuetify.display.width < 650"
            :span="$vuetify.display.width >= 500 ? 8 : 12"
          >
            <el-form-item prop="charger_capacity_kW" label="Charger Capacity kW: ">
              <el-input v-model="charger_data.charger_capacity_kW" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="charger_description" label="Charger Description: ">
              <el-input v-model="charger_data.charger_description" type="textarea" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
      <el-space fill style="width: 100%">
        <el-alert type="info" show-icon :closable="false">
          <p class="ma-0">Charger Port :</p>
        </el-alert>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="port_id" label="Port ID: ">
              <el-input v-model="charger_data.port_id" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="port_type" label="Port Type: ">
              <el-input v-model="charger_data.port_type" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="port_capacity_kw" label="Port Capacity kW: ">
              <el-input v-model="charger_data.port_capacity_kw" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="port_description" label="Port Description: ">
              <el-input v-model="charger_data.port_description" type="textarea" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>
    <!-- </el-row> -->
    <template #footer>
      <span class="dialog-footer">
        <!-- <el-button @click="close">Cancel</el-button>
        <el-button type="primary" @click="confirm"> Confirm </el-button> -->
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="confirm"
          color="#0D3937"
        >
          <i class="fa fa-check me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Confirm</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
// import "animate.css";
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return rawProps;
        // return {
        //   title: "",
        //   country: "",
        //   lat: "",
        //   lng: "",
        //   address_comment: "",
        //   charger_name: "",
        //   year_added: "",
        //   install_date: "",
        //   operational_date: "",
        //   certificate_number: "",
        //   make: "",
        //   model: "",
        //   charger_type: "",
        //   charger_capacity_kW: "",
        //   onsite_renewable: false,
        //   is_included: false,
        //   onsite_battery: false,
        //   description: "",
        //   port_id: "",
        //   port_type: "",
        // };
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      rules: {
        site_name: {
          required: true,
          message: "Site name is required.",
          trigger: "blur",
        },
        
        country: {
          required: true,
          message: "Country is required.",
          trigger: "blur",
        },
        lat: {
          type: "number",
          required: true,
          message: "Latitude is required.",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            return new Promise((resolve, reject) => {
              if (!this.isNumeric(value)) {
                reject("lat must be digit"); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
        lng: {
          type: "number",
          required: true,
          message: "Longitude is required.",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            console.log(value, Number.isInteger(value));
            return new Promise((resolve, reject) => {
              if (!this.isNumeric(value)) {
                reject("lng must be digit"); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
        street_name: {
          required: true,
          message: "Street name is required.",
          trigger: "blur",
        },
        suburb: {
          required: false,
          message: "Suburb is required if city is not provided.",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            return new Promise((resolve, reject) => {
              if (!value && !this.charger_data.city) {
                reject("Suburb is required if city is not provided."); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
        state: {
          required: false,
          message: "State is required if suburb is not provided.",
          trigger: "blur",
        },
        city: {
          required: false,
          message: "City is required if suburb is not provided.",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            return new Promise((resolve, reject) => {
              if (!value && !this.charger_data.suburb) {
                reject("City is required if suburb is not provided."); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
        postcode: {
          required: true,
          message: "Postcode is required.",
          trigger: "blur",
        },
        what3words: {
          required: false,
          message: "Please enter what3words.",
          trigger: "blur",
        },
        address_comment: {
          required: false,
          message: "Please enter address comment.",
          trigger: "blur",
        },
        charger_id: {
          required: true,
          message: "Charger ID is required.",
          trigger: "blur",
        },
        year_added: [
          {
            type: "number",
            // message: "year added must be digit",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              // console.log(
              //   value,
              //   !(value >= 2000 && value <= new Date().getFullYear())
              // );
              return new Promise((resolve, reject) => {
                if (!(value >= 2000 && value <= new Date().getFullYear())) {
                  reject("year added must be between 2000 and current year "); // reject with error message
                } else if (!this.isNumeric(value)) {
                  reject("year added must be digit"); // reject with error message
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        install_date: {
          required: false,
          type: "date",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            return new Promise((resolve, reject) => {
              if (!this.isValidDate(value)) {
                reject("install date must be valid date"); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
        operational_date: [
          {
            type: "date",
            required: true,
            message: "Operational date is required.",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isValidDate(value)) {
                  reject("operational date must be valid date"); // reject with error message
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        charger_type: {
          type: "enum",
          required: true,
          enum: [`AC`, "DC", "ac", "Ac", "aC", "dc", "Dc", "dC", ""],
          message: "Charger type is required.",
          trigger: "blur",
        },
        charger_capacity_kW: {
          type: "integer",
          required: true,
          message: "Charger capacity kW is required.",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            console.log(value);
            return new Promise((resolve, reject) => {
              if (!(value >= 1 && value <= 1000)) {
                reject("charger capacity kW must be between 1 and 1000"); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
        make: {
          required: true,
          message: "Make is required.",
          trigger: "blur",
        },
        model: {
          required: true,
          message: "Model is required.",
          trigger: "blur",
        },
        port_id: {
          required: true,
          message: "Port ID is required.",
          trigger: "blur",
        },
        port_type: {
          required: true,
          message: "Port type is required.",
          trigger: "blur",
        },
        port_capacity_kw: {
          type: "integer",
          required: true,
          message: "Port capacity kW is required.",
          trigger: "blur",
          asyncValidator: (rule, value) => {
            console.log(value);
            return new Promise((resolve, reject) => {
              if (!(value >= 1 && value <= 1000)) {
                reject("port capacity kW must be between 1 and 1000"); // reject with error message
              } else {
                resolve();
              }
            });
          },
        },
      },
      charger_data: {
        site_name: "",
        country: "",
        lat: "",
        lng: "",
        address_comment: "",
        charger_id: "",
        year_added: "",
        install_date: "",
        operational_date: "",
        certificate_number: "",
        make: "",
        model: "",
        charger_type: "",
        charger_capacity_kW: "",
        onsite_renewable: false,
        is_included: false,
        onsite_battery: false,
        description: "",
        port_id: "",
        port_type: "",
        port_capacity_kw: "",
        error_message: "",
      },
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      //console.log(this.data_modal);
      this.charger_data = JSON.parse(this.data_modal);
      this.charger_data.onsite_battery =
        this.charger_data.onsite_battery.toUpperCase() == "YES" ? true : false;
      this.charger_data.onsite_renewable =
        this.charger_data.onsite_renewable.toUpperCase() == "YES"
          ? true
          : false;
      console.log("After : ", this.charger_data);
    },
  },
  methods: {
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    isValidDate(dateString) {
      const dateRegex = /^\d{4}\/\d{2}\/\d{2}$/;
      if (dateRegex.test(dateString)) {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    async confirm() {
      // this.charger_data.error_message = [];
      // this.$emit("confirm_modal", this.charger_data);
      await this.$refs["ruleFormRef"].validate((valid, fields) => {
        if (valid) {
          // console.log("submit!");
          this.charger_data.error_message = [];
          this.$emit("confirm_modal", this.charger_data);
        } else {
          console.log("error submit!", fields);
        }
      });
    },
  },
};
</script>

<style>
.frm-class {
  /* height: 450px; */
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 5px;
}

.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}
.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
